<template>
  <v-app>

    <template>
      <v-container>
        <v-flex xs12>
          <v-breadcrumbs
            large
            :items="items"
            divider=">"
          ></v-breadcrumbs>
        </v-flex>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>Manage Lots</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="LotsFromDB"
          :search="search"
          class="elevation-1"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>{{ props.item.createdDate }}</td>
            <td>
              <router-link :to="`${'/lots/'}`+props.item.lotNumber">{{ props.item.lotNumber }}</router-link>
            </td>
            <td>{{ props.item.client }}</td>
            <td>{{ totalAsset(props.item.Assets) }}</td>
          </template>
        </v-data-table>

        <v-dialog
          v-model="deleteDialog"
          max-width="290"
        >
          <v-card>
            <v-card-title
              style="color:red"
              class="headline"
            >Delete</v-card-title>
            <v-card-text>Are you sure you want to delete location: {{name}} ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                flat="flat"
                @click="deleteDialog = false"
              >Cancel</v-btn>

              <v-btn
                color="primary"
                flat="flat"
                @click="deleteDialog = false; deleteItem(name)"
              >Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </template>

  </v-app>
</template>


<script>
const fb = require("../firebaseConfig.js");
import { mapFields } from "vuex-map-fields";

export default {
  name: "Lots",
  components: {
  },
  data () {
    return {
      search: '',
      items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Lots',
          disabled: false,
          to: 'lots'
        },
      ],
      messages: [],
      name: null,
      deleteDialog: false,
      currentOBJ: null,
      headers: [
        { text: "Created", value: "createdDate" },
        { text: "Lot Number", value: "lotNumber" },
        { text: "Customer", value: "client" },
        { text: "# of Asset", value: "totalAsset" },
      ],
      LotsFromDB: [],
    };
  },
  computed: {
    ...mapFields(["snackBarMessage",
      "snackBar", "snackBarcolor", "addLocationdialog"])
  },
  methods: {
    totalAsset: function (arr) {
      if (arr !== null) return arr.length;
    },
  },
  mounted () {
    fb.LotsCollections.onSnapshot(querySnapshot => {
      this.LotsFromDB = [];
      querySnapshot.forEach(doc => {
        this.LotsFromDB.push(doc.data());
      });
    });
  }
};
</script>


<style>
.iconPic {
  width: 40px;
  margin-left: 1%;
}
</style>